import React from 'react';
import SoundToggle from "../../components/SoundToggle";
import {useLocation} from "react-router-dom";

const CustomSound = ({isNotIframe}) => {
    const {pathname} = useLocation();
    const path = pathname.replace("/app/", "");
    const repId = path.replaceAll("/", "-");
    const id = ["lottery5D", "lottery1/12"].includes(path) ? `-${repId}` : "";

    const getPosition = () => {
        switch (path) {
            case "lottery5D":
                return isNotIframe ? {right: "2.5vw", top: "59vw",} : {right: "2.5vw", top: "61vw",};
            case "lottery12":
                return {
                    right: "19vw",
                    top: "1.2vw",
                };
            case "lottery99":
            case "lottery90":
                return {
                    right: "2.5vw",
                    top: "2.5vw",
                };
            default:
                return {
                    right: "2vw",
                    top: "1.2vw",
                }
        }
    }

    const colorSound = () => {
        switch (path) {
            case "lottery5":
            case "lottery12":
                return {isDanger: true};
            case "lottery6":
                return {isBlue: true};
            default:
                return {
                    isBlue: false,
                    isDanger: false
                }
        }
    }

    return (
        <div id={`mobile-sound${id}`} style={{
            position: "absolute",
            zIndex: 3,
            ...getPosition()
        }}>
            <SoundToggle isMobile isDanger={colorSound().isDanger} isBlue={colorSound().isBlue}/>
        </div>
    );
};

export default CustomSound;